import React, { Component } from 'react';
import { Form } from 'antd';
import Translate from 'react-translate-component';

import { formItemLayout } from 'constants/formItemLayout';
import FileUploader from 'components/modals/events/result/forms/FileUploader';
import DocumentList from 'components/common/fields/DocumentList';

export default class DocumentField extends Component {
    render() {
        return (
            <div className="card">
                <div className="card-body">
                    { this.props.documents && (
                        <Form.Item label={<Translate content='metro.request.documentAttached' />} {...formItemLayout}>
                            <DocumentList documents={this.props.documents} />
                        </Form.Item>
                    )}

                    <Form.Item label={<Translate content='metro.request.documentAttach' />} {...formItemLayout}>
                        <FileUploader
                            name='documentsUpload'
                            documentType='other'
                            multiple={true}
                        />
                    </Form.Item>
                </div>
            </div>
        );
    }
}
